import Button from './Button';
import ServerError from './ServerError';
import LoadingProgressBar from './LoadingProgressBar';
import windowSize from 'react-window-size';
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Row, Col } from 'react-bootstrap';
import Iframe from 'react-iframe';
import _ from 'lodash';
import $ from 'jquery';

import { caseGetPdfPublicAction, caseGetPdfAction } from '../../actions/caseActions';
import { userMessageLogAction } from '../../actions/userActions';
import { isEmptyObject } from '../../validators/formValidators';
import { isPlaceholderSignature, getTextValue } from './../../helpers/utils';
import { placeholderPillColor } from '../../helpers/colors';

import { Document, Page, pdfjs } from 'react-pdf';

if (typeof window !== 'undefined') {
    pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;
}


class DocumentViewer extends PureComponent {
    constructor(props) {
        super(props);
        this.containerRef = React.createRef();
        this.renderPdfViewer = this.renderPdfViewer.bind(this);
        this.renderImageViewer = this.renderImageViewer.bind(this);
        this.refreshPdfUrl = this.refreshPdfUrl.bind(this);
        this.onDocumentLoad = this.onDocumentLoad.bind(this);
        this.customTextRenderer = this.customTextRenderer.bind(this);
        this.fillPendingPlaceholders = this.fillPendingPlaceholders.bind(this);
        this.getSpan = this.getSpan.bind(this);
        this.getValue = this.getValue.bind(this);
        this.currentPlaceholder = {};
        this.pendingPlaceholders = [];
        this.pendingPlaceholdersPages = [];
        this.state = {
            loading: false,
            serverError: undefined,
            successDialogOpen: false,
            ViewURL: undefined,
            DownloadURL: undefined,
            StorageType: undefined,
            Embed: undefined,
            email: undefined,
            pdfPages: 0,
            pdfType: 'pdf'
        }
    }

    onDocumentLoad({ numPages }) {
        this.setState({ pdfPages: numPages });
    }

    async refreshPdfUrl() {
        if (this.state.ViewURL) {
            this.setState({ViewURL: undefined, DownloadURL: undefined, StorageType: undefined, Embed: undefined});
        }

        let action;
        let args;
        if (this.props.file) {
            action = caseGetPdfAction;
            let folder = this.props.file['$Subfolder$'];
            if (!folder) {
                if (this.props.file['Type'] === 'doc_templates') {
                    folder = 'template/document';
                } else if (this.props.file['Type'] === 'documents') {
                    folder = 'notes'
                }
            }

            args = [
                this.props.caseId,
                folder,
                this.props.file['Name']
            ];

        } else {
            action = caseGetPdfPublicAction;
            args = [ this.props.publicHash ];
        }

        try {
            const result = await this.props.dispatch(action(...args));
            if (!result) {
                this.setState({
                    serverError: 'Error while retrieving pdf link.'
                });

                return;
            }

            this.setState({
                ViewURL: result.data.ViewURL,
                DownloadURL: result.data.DownloadURL,
                Embed: result.data.Embed,
                StorageType: result.data.StorageType
            });

        } catch(error) {
            this.setState({
                serverError: 'Error while downloading pdf: ' + JSON.stringify(error)
            });
        }
    }

    componentDidMount() {
        const fileName = ((this.props.file && this.props.file['Name']) || '').toLowerCase();
        const previewAvailable = (this.props.file && (
            fileName.endsWith('pdf') ||
            fileName.endsWith('docx') ||
            fileName.endsWith('jpg') ||
            fileName.endsWith('jpeg') ||
            fileName.endsWith('png') ||
            fileName.endsWith('gif') ||
            this.props.file['Type'] == 'doc_templates')) || 
            this.props.publicHash;

        if (!previewAvailable) {
            this.setState({ serverError: 'Preview not available for this file.' });
            return;
        }

        if (fileName.endsWith('pdf') || fileName.endsWith('docx')) {
            this.setState({pdfType: 'pdf'});
        } else {
            this.setState({pdfType: 'image'});
        }

        if (!this.state.ViewURL) {
            this.refreshPdfUrl();
        }

        this.componentWillReceiveProps(this.props);
    }

    componentWillReceiveProps(nextProps) {
        this.fillPendingPlaceholders(undefined);
     }

    getSpan(pageNo, index) {
        const pagesEl = $('.react-pdf__Page__textContent');
        if (pagesEl.length < pageNo) {
            return undefined;
        }

        const pageEl = pagesEl[pageNo];
        const spansEl = pageEl.children;
        if (spansEl.length < index) {
            return undefined;
        }

        return spansEl[index];
    }

    getValue(placeholder) {
        if (placeholder.startsWith('%')) {
            placeholder = placeholder.substr(1);
        }
        const placeholderLength = placeholder.length + 2;
        let value = getTextValue(this.props.placeholdersMap[placeholder]) || '';
        if (isPlaceholderSignature(placeholder)) {
            if (placeholder.endsWith('DateTime')) {
                value = '[SIGNATURE DATE]';
            } else {
                value = '[SIGNATURE]';
            }
        } else if (placeholder === 'payment.Signed') {
            value = '[SIGNATURE DATE]';
        }
        const valueLength = value.length;
        if (placeholderLength < 3) {
            return '!ERROR!';
        }
        if (valueLength == placeholderLength) {
            return value;
        }

        for (let i = valueLength; i < placeholderLength; i++) {
            value += ' ';
        }

        if (valueLength > placeholderLength) {
            value = value.substr(0, placeholderLength - 3) + '...';
        }

        return value;
    }

    fillPendingPlaceholders(pageNo) {
        if (pageNo !== undefined && !this.pendingPlaceholdersPages.find(p => p === pageNo)) {
            this.pendingPlaceholdersPages.unshift(pageNo);
        }

        if (this.pendingPlaceholdersPages.length != this.state.pdfPages) {
            return;
        }

        const placeholdersEl = $('mark.placeholder');
        for (let i = 0; i < placeholdersEl.length; i++) {
            const placeholderEl = placeholdersEl[i];
            const index = parseInt(placeholderEl.getAttribute('data-index'), 10);
            const placeholder = this.pendingPlaceholders[index];
            if (!placeholder) {
                // Placeholders were reset after this one was rendered (unbalanced braces in the template).
                continue;
            }

            placeholderEl.innerHTML = placeholder.value;
            placeholderEl.style.color = this.props.previewPlaceholders ? '#000' : 'transparent';
            placeholderEl.style.backgroundColor = this.props.previewPlaceholders ? placeholderPillColor : 'transparent';
        }
    }

    customTextRenderer(pageNumber, textItem) {
        let text = textItem.str;
        if (!this.props.placeholdersMap) {
            return text;
        }

        // Save all placeholder starting positions, name and value.
        const spanIndex = textItem.itemIndex;
        let start = -1;
        for (let chrIndex = 0; chrIndex < text.length; chrIndex++) {
            const chr = text[chrIndex];
            switch (chr) {
                case '{':
                    if (!isEmptyObject(this.currentPlaceholder)) {
                        // Do not dispatch caseSetServerError - leads to deadlock.
                        this.pendingPlaceholders = [];
                        this.currentPlaceholder = {};
                        return text;
                    }

                    this.currentPlaceholder = this.pendingPlaceholders.find(p => _.isEqual(p.start, {pageNumber, spanIndex, chrIndex}));
                    if (!this.currentPlaceholder) {
                        this.currentPlaceholder = {
                            placeholder: '',
                            value: '',
                            start: {pageNumber, spanIndex, chrIndex},
                            index: this.pendingPlaceholders.length,
                            done: false
                        };

                        this.pendingPlaceholders.push(this.currentPlaceholder);
                    }

                    if (start === -1) {
                        start = this.currentPlaceholder.index;
                    }

                    break;

                case '}':
                    if (isEmptyObject(this.currentPlaceholder)) {
                        // Do not dispatch caseSetServerError - leads to deadlock.
                        this.pendingPlaceholders = [];
                        return text;
                    }

                    const index = this.currentPlaceholder.index;
                    if (!this.pendingPlaceholders[index]) {
                        // Reset since this placeholder was started.
                        this.currentPlaceholder = {};
                        return text;
                    }

                    if (!this.pendingPlaceholders[index].done) {
                        this.pendingPlaceholders[index] = this.currentPlaceholder;
                        this.pendingPlaceholders[index].value = this.getValue(this.currentPlaceholder.placeholder);
                        this.pendingPlaceholders[index].done = true;
                    }

                    this.currentPlaceholder = {};
                    break;

                default:
                    if (!isEmptyObject(this.currentPlaceholder) && !this.currentPlaceholder.done) {
                        this.currentPlaceholder.placeholder += chr;
                    }

                    break;
            }
        }

        if (start >= 0 && this.pendingPlaceholders[start]) {
            const parts = [];
            let chrIndex = 0;
            const initial = this.pendingPlaceholders[start].start;
            for (; start < this.pendingPlaceholders.length; start++) {
                if (initial.pageNumber !== this.pendingPlaceholders[start].pageNumber && initial.spanIndex !== this.pendingPlaceholders[start].start.spanIndex) {
                    break;
                }

                parts.push(text.substring(chrIndex, this.pendingPlaceholders[start].start.chrIndex));
                parts.push((
                    <mark
                        style={{
                            'color': this.props.previewPlaceholders ? '#000' : 'transparent',
                            'backgroundColor': this.props.previewPlaceholders ? placeholderPillColor : 'transparent'
                        }}
                        className="placeholder"
                        data-index={this.pendingPlaceholders[start].index}>
                    {this.pendingPlaceholders[start].value}
                    </mark>));
                chrIndex = this.pendingPlaceholders[start].start.chrIndex + this.pendingPlaceholders[start].placeholder.length + 2;
            }

            parts.push(text.substring(chrIndex));
            text = (<span>{parts}</span>);
        }

        return text;
    }

    renderPdfViewer() {
        let pdfHeight = undefined;
        let pdfViewer = '';
        let pdfWidth = this.containerRef.current && this.containerRef.current.offsetWidth * 0.9;
        let paddingTop = this.props.windowHeight * 0.35;
        let padding = undefined;
        if (this.props.fitHeightToWindow) {
            pdfHeight = this.props.windowHeight * 0.9;
        }

        let loader = (
            <Row style={{'paddingTop': paddingTop, paddingRight: padding}}>
                <LoadingProgressBar loading={true} />
            </Row>
        );

        if (this.state.serverError) {
            pdfViewer = <ServerError error={this.state.serverError} />
        } else if (this.state.ViewURL) {
            if (this.state.Embed) {
                pdfViewer = (
                    <Iframe 
                        url={this.state.ViewURL}
                        styles={{height: this.props.windowHeight * 0.5, width: this.props.windowWidth * 0.53, paddingLeft: 0, overflowY: 'hidden', overflowX: 'hidden'}}
                        display="initial"
                        position="relative"
                    />
                );
            } else {
                pdfViewer = (
                    <div style={{height: pdfHeight, width: pdfWidth, paddingLeft: padding, overflowY: 'hidden', overflowX: 'hidden'}}>
                    <Document file={this.state.ViewURL}
                            onLoadSuccess={this.onDocumentLoad}
                            loading={loader}
                            onLoadError={error => {
                                console.log(error);
                                if (_.isObject(error) && error.name) {
                                    error = error.name;
                                }

                                if (error === 'MissingPDFException') {
                                    this.setState({ serverError: 'Document has been deleted.'});
                                } else {
                                    this.setState({ serverError: 'Document unavailable!'});
                                    this.props.dispatch(userMessageLogAction(`ERROR: PDF '${this.state.ViewURL}' loading failure: ${JSON.stringify(error)}`));
                                }
                            }}
                    >
                        {_.range(this.state.pdfPages).map(pageNumber => 
                            <div>
                                <Page
                                    pageNumber={pageNumber + 1}
                                    width={pdfWidth}
                                    customTextRenderer={textItem => this.customTextRenderer(pageNumber, textItem)}
                                    onRenderSuccess={() => this.fillPendingPlaceholders(pageNumber)}
                                />
                                <h6 style={{textAlign: 'center'}}>Page {pageNumber + 1} / {this.state.pdfPages}</h6>
                            </div>
                        )}
                    </Document>
                    </div>
                );
            }

        } else {
            pdfViewer = loader;
        }

        return (
            <div style={{overflow: 'hidden'}} ref={this.containerRef}>
            <Row>
                <Col xs={12}>
                {pdfViewer}
                </Col>
            </Row>
            </div>
        );
    }

    renderImageViewer() {
        let pdfHeight = undefined;
        let pdfViewer = '';
        let pdfWidth = this.containerRef.current && this.containerRef.current.offsetWidth;
        let paddingTop = this.props.windowHeight * 0.35;
        let padding = undefined;
        if (this.props.fitHeightToWindow) {
            pdfHeight = this.props.windowHeight * 0.9;
        }

        let loader = (
            <Row style={{'paddingTop': paddingTop, paddingRight: padding}}>
                <LoadingProgressBar loading={true} />
            </Row>
        );

        if (this.state.serverError) {
            pdfViewer = <ServerError error={this.state.serverError} />
        } else if (this.state.ViewURL) {
            if (this.state.Embed) {
                pdfViewer = (
                    <Iframe 
                        url={this.state.ViewURL}
                        styles={{height: this.props.windowHeight * 0.5, width: this.props.windowWidth * 0.53, paddingLeft: 0, overflowY: 'hidden', overflowX: 'hidden'}}
                        display="initial"
                        position="relative"
                    />
                );

            } else {
                pdfViewer = (
                    <div style={{height: pdfHeight, width: pdfWidth, overflowY: 'hidden', overflowX: 'auto'}}>
                    <img src={this.state.ViewURL} />
                    </div>
                );
            }

        } else {
            pdfViewer = loader;
        }

        return (
            <div style={{overflow: 'hidden'}} ref={this.containerRef}>
            <Row>
                <Col xs={12}>
                {pdfViewer}
                </Col>
            </Row>
            </div>
        );
    }

    render() {
        if (this.state.pdfType == 'pdf') {
            return this.renderPdfViewer();
        } else {
            return this.renderImageViewer();
        }

    }
}

const mapStateToProps = (state, ownProps) => {
    let publicHash = state.routing.locationBeforeTransitions.pathname;
    publicHash = publicHash.substring(publicHash.lastIndexOf('/') + 1);
    return {
        publicHash
    }
};

DocumentViewer.propTypes = {
    file: PropTypes.object,
    caseId: PropTypes.number,
    download: PropTypes.bool,
    fitHeightToWindow: PropTypes.bool,
    placeholdersMap: PropTypes.object
};

export default connect(mapStateToProps)(windowSize(DocumentViewer));
